<template>
  <div id="footer" class="container-fluid">
    <div class="flex">
      <div>
        <div class="flex">
          <div><img src="https://yn-immshop.oss-cn-qingdao.aliyuncs.com/1/IHD__HOME__IMAGE/2023/09/01/256336421f354d91bc82c6ffc26a2b00.jpg"></div>
          <div @click="service_kf"><img src="https://yn-immshop.oss-cn-qingdao.aliyuncs.com/1/IHD__HOME__IMAGE/2023/09/01/2245227641f949ceab91240334d76a3e.jpg"></div>
        </div>
        <div class="flex"> 
          <div><img src="https://yn-immshop.oss-cn-qingdao.aliyuncs.com/1/IHD__HOME__IMAGE/2023/09/01/574c2308c69f442f8734417dcf150d24.jpg"></div>
          <div><img src="https://yn-immshop.oss-cn-qingdao.aliyuncs.com/1/IHD__HOME__IMAGE/2023/09/01/9917d325d4bd43c0a64ddd41e97ea37c.jpg"></div>
          <div><img src="https://yn-immshop.oss-cn-qingdao.aliyuncs.com/1/IHD__HOME__IMAGE/2023/09/01/b6a57f2469264b3b8d0ec72129e542cb.jpg"></div>
          <div><img src="https://yn-immshop.oss-cn-qingdao.aliyuncs.com/1/IHD__HOME__IMAGE/2023/09/01/7baa4f387af7494bbeea6a73ada158f6.jpg"></div>
          <div><img src="https://yn-immshop.oss-cn-qingdao.aliyuncs.com/1/IHD__HOME__IMAGE/2023/09/01/005fbbbda46d43b98eb58628c3404d75.jpg"></div>
        </div>
      </div>
      <div><img src="https://yn-immshop.oss-cn-qingdao.aliyuncs.com/1/IHD__HOME__IMAGE/2023/09/01/7a9f6f226e554d9bb72ec0bfe444be61.jpg"></div>
    </div>
    <div><img src="https://yn-immshop.oss-cn-qingdao.aliyuncs.com/1/IHD__HOME__IMAGE/2023/09/01/2ec04adae5bd4c9fb847e20e6736ce0f.jpg">
    <p class="copy">北京云能互联科技有限公司版权所有&nbsp;<a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">京ICP备19016815号-1</a></p>
    </div>

    <a :href="'tel:' + telPhone" ref="telPhone" style="display: none"></a>
  </div>
</template>
<script>
// import {buryingPoint} from '@/utils/utils.js'
export default {
  name: "Footer",
  data() {
    return {
      telPhone: "4006001831",
    };
  },
  methods: {
    service_kf() {
      //客服电话
      this.$refs.telPhone.click();
    },
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  /* background: #474747; */
  /* background: #222; */
  overflow: hidden;
  text-align: center;
}
#footer .footer-flex{
  margin-top: 35px;
  display: flex;
  justify-content: space-evenly;
  text-align: left;
}
img{
  width: 100%;
}
#footer .footer-flex .flex-item{
 width: 20%;
}
#footer .footer-flex .fitem-max{
 width: 40%;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 10px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 5px 0;
}
.link{
  line-height: 25px;
}
.hrefs:hover{
cursor:pointer;
color: red;
}
.flex{
  display: flex;
}
.marn{
  text-align: center;
  border-top: 2px solid #353535;
  width: 90%;
  margin: 0 auto;
}
/* .footicon img{
  width: 50%;
  height: 50%;
} */
.email_wx {
  margin-top: 20px;
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #000;
  font-size: 20px;
  position: relative;
  bottom: 50px;
}
.copy > a{
  color: #000;
}
.copy > a:hover{
  color: red;
}
@media screen and (max-width: 768px) {
  #footer .footer-flex{
  margin-top: 35px;
  display: block;
}
#footer .footer-flex .flex-item{
 width: 100%;
}
  .title {
    font-size: 20px;
    text-align: center;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
  color: #000;
  font-size: 10px;
  position: relative;
  bottom: 5px;
}
  /* .copy {
    font-size: 12px;
    margin: 10px 0 20px;
  } */
  /* .footicon img{
    margin: 0 auto;
  width: 20%;
  height: 20%;
} */
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue